// Satu build dipakai semua tenant (kai/nuno/demo). Yang membedakan hanya
// environment container, dirender ke /config.js saat start (docker/40-render-config.sh).
//
// Urutan prioritas:
//   1. runtime  — window.__APP_CONFIG__ dari /config.js
//   2. build    — process.env.VUE_APP_* dari .env, di-inline webpack
//   3. fallback — nilai default di bawah
//
// .env tidak ikut ter-commit, jadi di CI lapisan (2) selalu kosong.

const runtime = (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

// String kosong dianggap belum di-set, karena itu `||` bukan `??`.
const conf = (runtimeValue, buildValue, fallback) =>
  runtimeValue || buildValue || fallback;

export const apiUrl = {
  prod: conf(
    runtime.VUE_APP_BACKEND_URL_PROD,
    process.env.VUE_APP_BACKEND_URL_PROD,
    "https://backend.omset.co.id"
  ),
  dev: conf(
    runtime.VUE_APP_BACKEND_URL_DEV,
    process.env.VUE_APP_BACKEND_URL_DEV,
    "https://localhost:7267"
  ),

  business: {
    name: conf(
      runtime.VUE_APP_BUSINESS_NAME,
      process.env.VUE_APP_BUSINESS_NAME,
      "Kai"
    ),
    // Fallback ke id Kai berbahaya bila container lupa set variabel ini —
    // kasir tenant lain akan melihat data Kai. Entrypoint container menolak
    // start kalau VUE_APP_BUSINESS_ID_PROD kosong.
    prodId: conf(
      runtime.VUE_APP_BUSINESS_ID_PROD,
      process.env.VUE_APP_BUSINESS_ID_PROD,
      "978f5d99-5104-4fe2-a3ba-a3e043f1b522"
    ),
    devId: conf(
      runtime.VUE_APP_BUSINESS_ID_DEV,
      process.env.VUE_APP_BUSINESS_ID_DEV,
      "978f5d99-5104-4fe2-a3ba-a3e043f1b522"
    ),
  },

  backoffice: {
    prod: conf(
      runtime.VUE_APP_BACKOFFICE_PROD,
      process.env.VUE_APP_BACKOFFICE_PROD,
      "https://backoffice.omset.co.id"
    ),
    dev: conf(
      runtime.VUE_APP_BACKOFFICE_DEV,
      process.env.VUE_APP_BACKOFFICE_DEV,
      "http://localhost:3000"
    ),
  },
};

// URL backend yang sedang aktif, sesuai NODE_ENV.
export const backendUrl =
  process.env.NODE_ENV === "production" ? apiUrl.prod : apiUrl.dev;
